import {
  Fragment,
  forwardRef,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { Box, Flex } from "rebass";
import ExpandImage from "./ExpandImage";
import { Label } from "@rebass/forms";
import { BsChevronDown, BsColumnsGap } from "react-icons/bs";
import { CiCamera } from "react-icons/ci";
import { HiOutlineChevronDoubleLeft } from "react-icons/hi";
import { getLocalizedString } from "../../utils";
import config from "../../utils/globalConfig";
import { Price } from "../common/Price";
import AvailabilityMobile from "./AvailabilityMobile";
import MoreInfoMobile from "./MoreInfoMobile";
import Reversible from "../../icons/Reversible";
import Ccontinuous from "../../icons/Ccontinuous";
import { PlusButton } from "../PlusButton/PlusButton";
import { ModalColor } from "../PlusButton/modalColor/ModalColor";
import { ColorBoxMobile } from "./ColorBoxMobile";
import { useDispatch, useSelector } from "react-redux";
import { systemActions, yodaCatalogueActions } from "../../logic/actions";
import { filter } from "lodash";
import I360Simple from "../../icons/I360Simple";
const MobileProductDetail = forwardRef(
  (
    { catalogueSelected, filteredCatalogue, seasonCode, onClose, type },
    ref,
  ) => {
    const anchor360 = useRef();
    const { offsetTop } = useSelector((state) => state.system);
    const { catalogueItemDetails, catalogueItemDetailsSwap, catalogue } =
      useSelector((state) => state.yodaCatalogue);
    const { orderRowDetails, order } = useSelector((state) => state.yodaOrders);
    const { customer } = useSelector((state) => state.yodaCustomer);
    const dispatch = useDispatch();

    const [pantone, setPantone] = useState([]);
    const [showExpandImage, setShowExpandImage] = useState(false);
    const [showInfoView, setShowInfoView] = useState(false);
    const [showAvailabilityModal, setShowAvailabilityModal] = useState(false);
    const [openModalColor, setOpenModalColor] = useState(false);
    const [catalogueEl, setCatalogueEl] = useState();
    const [pantoneSingle, setPantoneSingle] = useState();

    const {
      productId: id,
      catalog: images,
      modelCode,
      reversible,
      continuous,
      price: prices,
      imagedefault,
    } = filteredCatalogue?.find(
      (catalogueItem) => catalogueSelected == catalogueItem?.productId,
    ) || {};

    const imagesSrc =
      images
        ?.map((m) => m.images)
        ?.flat?.()
        ?.reduce?.((prev, image) => {
          if (
            image.type === "FRONT_GHOST" &&
            prev.find(
              (prevAddedImage) =>
                prevAddedImage.type === "FRONT_GHOST" &&
                prevAddedImage.link === image.link,
            )
          ) {
            return prev;
          } else return [...prev, image];
        }, []) || [];

    const lang = localStorage.getItem("B2BLanguage") == "ITA" ? "it" : "en";
    const catalogueItems = useMemo(
      () =>
        type === config.ORDER_TYPE_REORDER
          ? catalogueItemDetails
          : catalogueItemDetailsSwap,
      [catalogueItemDetails, catalogueItemDetailsSwap, type],
    );

    function openInfoView() {
      setShowInfoView(true);
    }

    function close(event) {
      dispatch(systemActions.closeCatalogueItem());
      setShowAvailabilityModal(false);
    }

    function showAvailabilityModalHandler(event, e, i) {
      event.preventDefault();
      setShowAvailabilityModal(true);
      setCatalogueEl(e);
      setPantoneSingle(pantone[i]);
    }

    function changeColor() {
      setShowAvailabilityModal(false);
      setOpenModalColor(true);
    }

    function calculatedColors() {
      let tmpArr = {};
      catalogueItems[id]?.catalog?.map((e) => {
        if (tmpArr[e.colorCode] === undefined) {
          tmpArr[e.colorCode] = {
            colorDescription: e.colorDescription?.[lang] || "",
            rgb: e.rgb,
            code: e.colorCode,
            values: [
              {
                size: e.size,
                sizeCode: e.sizeRowId,
                quantity: e.quantity,
              },
            ],
          };
        } else {
          tmpArr[e.colorCode].values.push({
            size: e.size,
            sizeCode: e.sizeRowId,
            quantity: e.quantity,
          });
        }
      });
      if (tmpArr === undefined) {
        return [];
      }

      let tmpArr2 = Object.keys(tmpArr).map(function (key) {
        return tmpArr[key];
      });

      return Array.from(tmpArr2);
    }

    // SWAP FUNCTIONS
    function display360() {
      const link = imagesSrc?.find((i) => i.type === "360")?.link;
      if (!link) return;
      anchor360.current.href = link;
      anchor360.current.target = "_blank";
      anchor360.current.click();
    }

    function getAvgPrice() {
      let tmpArr = catalogue?.filter((f) => f.productId == id)[0]?.catalog;
      if (tmpArr) {
        return Math.max(...tmpArr.map((m) => m.price));
      }
      return 0;
    }
    // END - SWAP FUNCTIONS

    let totalQuantity = 0;
    let totalPrice = 0;

    let totalQuantityC = {};
    let totalPriceC = {};

    calculatedColors().map((e, index) => {
      order &&
        order?.customData?.doors &&
        order.customData.doors.map((d, idx) => {
          let catalogId = catalogueItems[id]?.catalog.filter(
            (f) => f.colorCode == e.code,
          )[0].catalogId;

          let tmpArr = filter(
            orderRowDetails,
            (k, v) =>
              k.catalogId == catalogId &&
              d == k.customData.doorId &&
              k.customData.typeId == type,
          );

          tmpArr.forEach((e1) => {
            totalQuantity += e1.currentQuantity;
            totalPrice += e1.price;

            if (totalQuantityC[e.code] == undefined) {
              totalQuantityC[e.code] = e1.currentQuantity;
            } else {
              totalQuantityC[e.code] += e1.currentQuantity;
            }

            if (totalPriceC[e.code] == undefined) {
              totalPriceC[e.code] = e1.price;
            } else {
              totalPriceC[e.code] += e1.price;
            }
          });
        });
    });

    useEffect(() => {
      const el = catalogue.filter((e) => e.productId === id);
      const pnt = el[0]?.catalog?.map((e) => e.pantone);
      setPantone(pnt);
    }, [catalogue, id]);

    useEffect(() => {
      if (window) {
        window.scroll(0, 0);
      }
      if (type === config.ORDER_TYPE_SWAP) {
        dispatch(yodaCatalogueActions.getOneSwap(customer?.id, id, seasonCode));
      } else {
        dispatch(yodaCatalogueActions.getOne(customer?.id, id, seasonCode));
      }
      dispatch(systemActions.toggleMinimizeUI(true));
      // eslint-disable-next-line react-hooks/exhaustive-deps
      return () => {
        dispatch(systemActions.toggleMinimizeUI(false));
        onClose?.(catalogueSelected);
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
      <>
        <Box width="100%" bg="white" {...{ ref }}>
          <Flex flexDirection={"column"} width="100%">
            <Flex
              width="100%"
              flexDirection="column"
              sx={{ position: "sticky", top: offsetTop }}
            >
              <Flex
                width="100%"
                height="35vh"
                sx={{ position: "relative", background: "#fff" }}
              >
                {/* Image container */}
                <Flex
                  mt="15px"
                  sx={{
                    zIndex: 3,
                    position: "fixed",
                    gap: "10px",
                    background: "#fff",
                    borderRadius: "8px",
                    padding: "1px 4px",
                  }}
                  alignItems="center"
                  ml="10px"
                >
                  <CiCamera
                    size="25px"
                    onClick={() => setShowExpandImage(!showExpandImage)}
                  />
                  {imagesSrc?.find((i) => i.type === "360")?.link && (
                    <a ref={anchor360} href="360">
                      <div onClick={display360}>
                        <I360Simple style={{ width: "25px", height: "25px" }} />
                      </div>
                    </a>
                  )}
                  {type === config.ORDER_TYPE_REORDER && continuous > 0 ? (
                    <Ccontinuous />
                  ) : null}
                  {type === config.ORDER_TYPE_REORDER && reversible > 0 ? (
                    <Reversible />
                  ) : null}
                </Flex>

                {showInfoView && (
                  <MoreInfoMobile
                    sku={catalogueItems[id]?.sku?.[lang]}
                    shape={catalogueItems[id]?.shape?.[lang]}
                    pockets={catalogueItems[id]?.pockets?.[lang]}
                    hood={catalogueItems[id]?.hood?.[lang]}
                    padding={catalogueItems[id]?.padding?.[lang]}
                    sleeves={catalogueItems[id]?.sleevs?.[lang]}
                    tag={catalogueItems[id]?.tag?.[lang]}
                    fit={catalogueItems[id]?.fit?.[lang]}
                    madeIn={catalogueItems[id]?.madeIn?.[lang]}
                    closure={catalogueItems[id]?.closure?.[lang]}
                    matDescription={
                      catalogueItems[id]?.materialDescription?.[lang]
                    }
                    matComposition={
                      catalogueItems[id]?.materialComposition?.[lang]
                    }
                    price={prices}
                    material={catalogueItems[id]?.materialCode}
                    model={modelCode}
                    onClose={() => setShowInfoView(false)}
                    {...(type === config.ORDER_TYPE_SWAP && {
                      fixedPrice: getAvgPrice(),
                    })}
                  />
                )}
                <Flex
                  style={{
                    zIndex: 2,
                    height: "100%",
                    position: "absolute",
                    left: "-36px",
                    top: 0,
                    padding: "45px 0",
                  }}
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <Flex
                    style={{
                      transform: "rotate(-90deg)",
                      zIndex: 3,
                      borderRadius: "0px 0px 5px 5px",
                      border: "1px solid #232323",
                      whiteSpace: "nowrap",
                    }}
                    height="30px"
                    width="100px"
                    px="10px"
                    alignItems="center"
                    justifyContent="space-between"
                    bg="white"
                    onClick={openInfoView}
                  >
                    <span
                      style={{
                        fontSize: "10px",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        width: "60px",
                        textAlign: "center",
                      }}
                    >
                      {getLocalizedString("INFO_MOBILE")}
                    </span>
                    <BsChevronDown size="10px" />
                  </Flex>
                </Flex>
                <Flex
                  overflowX="auto"
                  justifyContent={
                    imagesSrc?.length < 3 ? "space-around" : "unset"
                  }
                  sx={{ flex: 1 }}
                >
                  {!imagesSrc?.find(
                    (image) => image?.link === imagedefault,
                  ) && (
                    <img
                      src={imagedefault?.length > 0 ? imagedefault : ""}
                      alt=""
                      style={{
                        maxHeight: "330px",
                        objectFit: "contain",
                        pointerEvents: "none",
                      }}
                    />
                  )}
                  {imagesSrc?.map((im, i) => (
                    <img
                      key={i}
                      src={im.link}
                      alt=""
                      style={{
                        maxHeight: "330px",
                        objectFit: "contain",
                        pointerEvents: "none",
                      }}
                    />
                  ))}
                </Flex>
              </Flex>
              <Flex height="45px" alignItems="center">
                {/*black row */}
                <Flex
                  bg={"#232323"}
                  onClick={close}
                  height="100%"
                  width="75px"
                  // pb="10px"
                  sx={{ zIndex: 3, borderRight: "2px solid #fff" }}
                >
                  <Flex alignItems="center" ml="5px">
                    <BsColumnsGap color="white" size="20px" />
                  </Flex>
                  <Flex alignItems="center" ml="10px">
                    <HiOutlineChevronDoubleLeft color="white" size="20px" />
                  </Flex>
                </Flex>
                <Flex
                  bg="#303130"
                  height="100%"
                  width="calc(100% - 75px)"
                  px="10px"
                  alignItems="center"
                >
                  <span
                    style={{
                      fontStyle: "italic",
                      color: "white",
                      width: "unset",
                      marginRight: "10px",
                      marginLeft: "10px",
                    }}
                  >
                    {getLocalizedString("Prezzo")}:
                  </span>
                  <Label color="white">
                    <Price
                      price={
                        type === config.ORDER_TYPE_SWAP ? getAvgPrice() : prices
                      }
                    />
                  </Label>

                  <PlusButton onClick={() => setOpenModalColor(true)} />

                  {openModalColor && (
                    <ModalColor
                      colors={calculatedColors()}
                      type={
                        type === config.ORDER_TYPE_REORDER ? "REORDER" : "SWAP"
                      }
                      onClose={() => setOpenModalColor(false)}
                      onClickColors={showAvailabilityModalHandler}
                    />
                  )}
                </Flex>
              </Flex>
              {/* MOBILE COLORS */}
              <Flex
                flexDirection="column"
                sx={{ background: "#fff", paddingBottom: "10px" }}
              >
                {/*available colors */}
                <span
                  style={{
                    fontStyle: "italic",
                    fontSize: "12px",
                    marginTop: "15px",
                    marginLeft: "15px",
                  }}
                >
                  {getLocalizedString("COLORS AVAILABILITY")}
                </span>
                <Flex
                  mt="10px"
                  style={{ gap: "10px", overflowX: "auto" }}
                  height="70px"
                  px="10px"
                  className="box-color-mobile"
                >
                  {calculatedColors().map((e, i) => (
                    <Fragment key={i}>
                      <ColorBoxMobile
                        onClick={(event) =>
                          showAvailabilityModalHandler(event, e, i)
                        }
                        colorDescription={e.colorDescription}
                        id={e.id}
                        code={e.code}
                        rgbColor={e.rgb}
                        type={
                          type === config.ORDER_TYPE_REORDER
                            ? "REORDER"
                            : "SWAP"
                        }
                      />

                      {showAvailabilityModal && (
                        <AvailabilityMobile
                          element={catalogueEl}
                          pantone={pantoneSingle}
                          calculatedColors={calculatedColors()}
                          price={prices}
                          id={id}
                          onCancel={() => setShowAvailabilityModal(false)}
                          totalQnt={totalQuantity}
                          totalPrice={totalPrice}
                          onClose={close}
                          changeColor={changeColor}
                          {...{ type }}
                        />
                      )}
                    </Fragment>
                  ))}
                </Flex>
              </Flex>
              {/* END - MOBILE COLORS */}
            </Flex>
            {/* PRODUCT DETAIL */}
            <Flex flexDirection="column" sx={{ flexGrow: 1 }}>
              <Box sx={{ paddingBottom: "10px" }}>
                <Flex flexDirection="column" px="10px" mt="10px">
                  <div>
                    <span style={{ fontWeight: "bold" }}>
                      {getLocalizedString("Codice modello")}:{" "}
                    </span>
                    <span>{modelCode}</span>
                  </div>
                  <div>
                    <span style={{ fontWeight: "bold" }}>
                      {getLocalizedString("Codice materiale")}:{" "}
                    </span>
                    <span>{catalogueItems[id]?.materialCode}</span>
                  </div>
                  <div>
                    <span style={{ fontWeight: "bold" }}>
                      {getLocalizedString("Codice collezione")}:{" "}
                    </span>
                    <span>{catalogueItems[id]?.collectionCode}</span>
                  </div>
                  <div>
                    <span style={{ fontWeight: "bold" }}>
                      {getLocalizedString("Codice linea")}:{" "}
                    </span>
                    <span>{catalogueItems[id]?.lineCode}</span>
                  </div>
                  <div>
                    <span style={{ fontWeight: "bold" }}>
                      {getLocalizedString("Descrizione linea")}:{" "}
                    </span>
                    <span>
                      {catalogueItems[id]?.lineDescription
                        ? catalogueItems[id]?.lineDescription[lang]
                        : ""}
                    </span>
                  </div>
                  <div>
                    <span style={{ fontWeight: "bold" }}>
                      {getLocalizedString("Collezione")}:{" "}
                    </span>
                    <span>
                      {catalogueItems[id]?.collectionDescription?.[lang] || ""}
                    </span>
                  </div>
                </Flex>
                <Flex flexDirection="column" px="10px" mt="10px">
                  <span style={{ fontWeight: "bold" }}>
                    {getLocalizedString("Descrizione modello")}:{" "}
                  </span>
                  <span>
                    {catalogueItems[id]?.modelDescription?.[lang] || ""}
                  </span>
                </Flex>
                <Flex flexDirection="column" px="10px" mt="10px">
                  <span style={{ fontWeight: "bold" }}>
                    {getLocalizedString("Taglie")}:{" "}
                  </span>
                  <span>
                    {catalogueItems[id]?.sizes
                      ?.sort((a, b) => a - b)
                      .join(" | ") || ""}
                  </span>
                </Flex>
                <Flex flexDirection="column" px="10px" mt="10px">
                  <span style={{ fontWeight: "bold" }}>
                    {getLocalizedString("Descrizione materiale")}:{" "}
                  </span>
                  <span>
                    {catalogueItems[id]?.materialDescription?.[lang] || ""}
                  </span>
                </Flex>
              </Box>
            </Flex>
            {/* END - PRODUCT DETAIL */}
          </Flex>
        </Box>
        {showExpandImage && (
          <ExpandImage
            imgs={imagesSrc}
            onClose={() => setShowExpandImage(!showExpandImage)}
          />
        )}
      </>
    );
  },
);
export default MobileProductDetail;
